module.exports = __webpack_public_path__ + "media/unipod/icon-live-testing-white-6a549aae.svg";